import { AxiosRequestConfig } from "axios";
import { instance } from "../api-instance";
import { softValidateResponse } from "@/server/validation";
import {
  DocumentsForPagesResponseSchema,
  DocumentsForRegistrationSchema,
  GetFileBodyResponseSchema,
} from "./schemas";

export const DocumentRulesApi = {
  documentsForRegistration() {
    return instance
      .get(`document/documentsForRegistration`)
      .then(softValidateResponse(DocumentsForRegistrationSchema))
      .then((res) => res.data);
  },

  documentsForPage(
    body: unknown,
    options: AxiosRequestConfig
  ): Promise<unknown> {
    return instance
      .post(`document/documentsForPage`, body, options)
      .then((res) => res.data);
  },

  documentsForPages(
    payload: {
      applicationId: string;
      formPageIds: string[];
      offerSum?: number;
      onlyNew: boolean;
    },
    options: AxiosRequestConfig
  ) {
    return instance
      .post(`document/documentsForPages`, payload, options)
      .then(softValidateResponse(DocumentsForPagesResponseSchema))
      .then((res) => res.data);
  },

  saveDocuments(data: unknown): Promise<unknown> {
    return instance
      .post("document/saveDocuments", data)
      .then((res) => res.data);
  },

  saveDocumentLogFiles(data: unknown): Promise<unknown> {
    return instance
      .post("document/saveDocumentRulesLogFiles", data)
      .then((res) => res.data);
  },

  getFileBody(applicationId: string, documentRulesId: string) {
    return instance
      .get(
        `document/getFileBody?applicationId=${applicationId}&documentRulesId=${documentRulesId}`
      )
      .then(softValidateResponse(GetFileBodyResponseSchema))
      .then((res) => res.data);
  },
};
